import "styles/resultsWindow.less";

import React, { useCallback, useContext } from "react";

import { Typography } from "antd";
import { useNavigate } from "react-router-dom";

import BreakdownSubsection from "./BreakdownSubsection";
import { AppContext } from "../../../../App";
import { scrollToElement, scrollToTop } from "../../../../utils/common";

const ResultsWindow: React.FC = () => {
    const navigate = useNavigate();
    const { isMobile, toggleFormScale, isAuth } = useContext(AppContext);
    const grossIncomeCurrentYear = 50000;
    const grossIncomePreviousYear = 50000;
    const pensionContrCurrentYear = 1050;
    const pensionContrPreviousYear = 1050;
    const personalAllowanceCurrentYear = 1050;
    const personalALlowancePreviousYear = 1000;
    const taxableIncomeCurrentYear = 48950;
    const taxableIncomePreviousYear = 48950;
    const basicRateCurrentYear = 8400;
    const basicRatePreviousYear = 8000;
    const higherRateCurrentYear = 2780;
    const higherRatePreviousYear = 3580;
    const additionalRateCurrentYear = 2780;
    const additionalRatePreviousYear = 3580;
    const class4CurrentYear = 1762;
    const class4PreviousYear = 1713;
    const class2CurrentYear = 82;
    const class2PreviousYear = 79;
    const studentLoanRepayCurrentYear = 1053;
    const studentLoanRepayPreviousYear = 1053;
    const taxLiabilityCurrentYear = 171112;
    const taxLiabilityPreviousYear = 17362;
    const annualIncomeCurrentYear = 33853;
    const annualIncomePreviousYear = 33451;
    const monthlyIncomeCurrentYear = 2821;
    const monthlyIncomePreviousYear = 2788;
    const weeklyIncomeCurrentYear = 651;
    const weeklyIncomePreviousYear = 643;
    const annualDisposableIncome = 402;
    const monthlyDisposableIncome = 33;
    const weeklyDisposableIncome = 8;
    const handleTryButtonClick = useCallback(
        () => {
            if (isAuth) {
                scrollToTop();
                navigate("/auth");
            } else if (isMobile) {
                scrollToTop();
                navigate("/sign-up?step=personalInfo");
            } else {
                toggleFormScale(true);
                scrollToElement("sign-up");
            }
        },
        [isMobile, navigate, toggleFormScale, isAuth]
    );
    return (
        <div>
            <div className={isMobile ? "results-window__container-mobile" : "results-window__container-desktop"}>
                <Typography className={"results-window__header-text"}>
                    Your Tax Liability Estimate
                </Typography>
                <Typography className={"results-window__tax-amount-text"}>
                    £0
                </Typography>
                <Typography className={"results-window__description-text"} style={isMobile ? { width: "300px" } : {}}>
                    This is an estimated tax calculation based on the details you've entered. For a complete and accurate result, sign up with TaxZap.
                </Typography>
                <div className={isMobile ? "results-window__year-container-mobile" : "results-window__year-container-desktop"}>
                    <Typography className={"results-window__year-text"} style={isMobile ? { marginLeft: "20px" } : { marginLeft: "180px" }}>
                        2024/2025
                    </Typography>
                    <Typography className={"results-window__year-text"} style={isMobile ? { marginLeft: "20px" } : { marginLeft: "180px" }}>
                        2023/2024
                    </Typography>
                </div>
                <BreakdownSubsection subsectionName="Gross Income" currentYearAmount={grossIncomeCurrentYear} previousYearAmount={grossIncomePreviousYear} isBold={false} hasLargeMargin={false} isTotalDifference={false} />
                <BreakdownSubsection subsectionName="Pension Contributions" currentYearAmount={pensionContrCurrentYear} previousYearAmount={pensionContrPreviousYear} isBold={false} hasLargeMargin={false} isTotalDifference={false} />
                <BreakdownSubsection subsectionName="Personal Allowance" currentYearAmount={personalAllowanceCurrentYear} previousYearAmount={personalALlowancePreviousYear} isBold={false} hasLargeMargin={false} isTotalDifference={false} />
                <div className={"results-window__line-divider"} style={isMobile ? { marginBottom: "10px" } : {}}/>
                <BreakdownSubsection subsectionName="Taxable Income" currentYearAmount={taxableIncomeCurrentYear} previousYearAmount={taxableIncomePreviousYear} isBold={false} hasLargeMargin={false} isTotalDifference={false} />
                <div className={"results-window__line-divider"} style={isMobile ? { marginBottom: "10px" } : {}}/>
                <BreakdownSubsection subsectionName="Basic Rate (20%)" currentYearAmount={basicRateCurrentYear} previousYearAmount={basicRatePreviousYear} isBold={false} hasLargeMargin={false} isTotalDifference={false} />
                <BreakdownSubsection subsectionName="Higher Rate (40%)" currentYearAmount={higherRateCurrentYear} previousYearAmount={higherRatePreviousYear} isBold={false} hasLargeMargin={false} isTotalDifference={false} />
                <BreakdownSubsection subsectionName="Additional Rate (45%)" currentYearAmount={additionalRateCurrentYear} previousYearAmount={additionalRatePreviousYear} isBold={false} hasLargeMargin={false} isTotalDifference={false} />
                <div className={"results-window__line-divider"} style={isMobile ? { marginBottom: "20px" } : {}}/>
                <BreakdownSubsection subsectionName="Class 4 National Insurance" currentYearAmount={class4CurrentYear} previousYearAmount={class4PreviousYear} isBold={false} hasLargeMargin={false} isTotalDifference={false} />
                <BreakdownSubsection subsectionName="Class 2 National Insurance" currentYearAmount={class2CurrentYear} previousYearAmount={class2PreviousYear} isBold={false} hasLargeMargin={false} isTotalDifference={false} />
                <div style={{ backgroundColor: "#FFFFFF", height: "1px", marginTop: "10px" }} />
                <BreakdownSubsection subsectionName="Student Loan Repayments" currentYearAmount={studentLoanRepayCurrentYear} previousYearAmount={studentLoanRepayPreviousYear} isBold={false} hasLargeMargin={false} isTotalDifference={false} />
                <div className={"results-window__line-divider"} style={isMobile ? { marginBottom: "10px" } : { marginBottom: "20px" }} />
                <BreakdownSubsection subsectionName="Total Tax Liability" currentYearAmount={taxLiabilityCurrentYear} previousYearAmount={taxLiabilityPreviousYear} isBold={true} hasLargeMargin={false} isTotalDifference={false} />
                <div className={"results-window__line-divider"} style={isMobile ? { marginBottom: "10px" } : {}}/>
                <BreakdownSubsection subsectionName="Net Annual Income" currentYearAmount={annualIncomeCurrentYear} previousYearAmount={annualIncomePreviousYear} isBold={false} hasLargeMargin={true} isTotalDifference={false} />
                <BreakdownSubsection subsectionName="Net Monthly Income" currentYearAmount={monthlyIncomeCurrentYear} previousYearAmount={monthlyIncomePreviousYear} isBold={false} hasLargeMargin={true} isTotalDifference={false} />
                <BreakdownSubsection subsectionName="Net Weekly Income" currentYearAmount={weeklyIncomeCurrentYear} previousYearAmount={weeklyIncomePreviousYear} isBold={false} hasLargeMargin={true} isTotalDifference={false} />
                <div className={"results-window__line-divider"} style={isMobile ? { marginTop: "10px" } : { marginTop: "0px" }} />
                <Typography className={"results-window__total-difference-text"} style={isMobile ? { marginBottom: "20px" } : { paddingLeft: "40px" }}>
                    Total difference between 2023 and 2024
                </Typography>
                <BreakdownSubsection subsectionName="Annual Disposable Income" currentYearAmount={0} previousYearAmount={annualDisposableIncome} isBold={false} hasLargeMargin={true} isTotalDifference={true} />
                <BreakdownSubsection subsectionName="Monthly Disposable Income" currentYearAmount={0} previousYearAmount={monthlyDisposableIncome} isBold={false} hasLargeMargin={true} isTotalDifference={true} />
                <BreakdownSubsection subsectionName="Weekly Disposable Income" currentYearAmount={0} previousYearAmount={weeklyDisposableIncome} isBold={false} hasLargeMargin={false} isTotalDifference={true} />
            </div>
            <div className={isMobile ? "results-window__try-taxzap-container-mobile" : "results-window__try-taxzap-container-desktop"}>
                <Typography className={"results-window__header-text"}>
                    You could lower your tax liability with TaxZap
                </Typography>
                <Typography className={"results-window__try-taxzap-text"}>
                    With TaxZap, you can securely connect your bank account and automatically claim all your business expenses, so you never miss a claim and overall pay less tax.
                </Typography>
                <Typography className={"results-window__try-taxzap-trust-text"}>
                    Trusted by over 125k tax payers.
                </Typography>
                <button
                    className={`shared__primary-button ${isMobile ? "results-window__button-width-100-percent" : "results-window__button-width-200px"}`}
                    onClick={handleTryButtonClick}
                >
                    Try TaxZap for Free
                </button>
            </div>
        </div>
    );
};

export default ResultsWindow;
